<template>
    <el-dialog class="productTypeDialog" :append-to-body="true" title="" :visible.sync="productShow" width="55%">
        <div class="top">
            <h2 style="color: red;">{{productInfo.productNameCn}}</h2>
            <span style="display: flex;margin-top: 10px">
               <h3>{{productInfo.bedInfo}}</h3>
               <span v-if="productInfo.id" style="margin-left: 20px">基础产品编号：{{productInfo.id}}</span>
           </span>
        </div>
        <el-divider></el-divider>
        <div class="bottom" style="display: flex">
            <div id="left" v-if="productInfo">
                <ProductPicture  ref="showPicture"></ProductPicture>
            </div>
            <div id="right" v-if="productInfo.productDetail">
                <p v-if="productInfo.productDetail.area">建筑面积：<span>{{productInfo.productDetail.area}}</span></p>
                <p v-if="productInfo.productDetail.useNumber">最多可住：<span>{{productInfo.productDetail.useNumber}}</span></p>
                <p v-if="productInfo.productDetail.floor">楼层：<span>{{productInfo.productDetail.floor}}</span></p>
                <p v-if="productInfo.bedInfo">床型：<span>{{productInfo.bedInfo}}</span></p>
                <p v-if="productInfo.productDetail.window">窗户：<span>{{productInfo.productDetail.window}}</span></p>
                <p v-if="productInfo.productDetail.isPets">宠物：<span>{{productInfo.productDetail.isPets}}</span></p>
                <p v-if="productInfo.productDetail.extraBedPolicy">加床：<span>{{productInfo.productDetail.extraBedPolicy}}</span></p>
                <p v-if="productInfo.productDetail.checkInInfo">入住时间：<span>{{productInfo.productDetail.checkInInfo}}</span></p>
                <p v-if="productInfo.productDetail.checkOutInfo">退房时间：<span>{{productInfo.productDetail.checkOutInfo}}</span></p>
            </div>
        </div>
    </el-dialog>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具 js，第三方插件 js，json 文件，图片文件等等）
// 例如：import  《组件名称》  from '《组件路径》 ';
import ProductPicture from "@/components/ProductPicture.vue";
export default {
    name: "HotelProductInfo",
    data() {
        // 这里存放数据
        return {
            productShow: false,
            productInfo: ''
        }
    },
    // import 引入的组件需要注入到对象中才能使用
    components: {ProductPicture},
    props: {},
    // 方法集合
    methods: {
        init(productInfo) {
            console.log("kjll",productInfo)
            this.productShow = true
            this.productInfo = productInfo
            this.$nextTick(() => {
                this.$refs.showPicture.init(productInfo.pictures,0)
            })
        }
    },
    // 计算属性 类似于 data 概念
    computed: {},
    // 监控 data 中的数据变化
    watch: {},
    //过滤器
    filters: {},
    // 生命周期 - 创建之前
    beforeCreate() {
    },
    // 生命周期 - 创建完成（可以访问当前this 实例）
    created() {
    },
    // 生命周期 - 挂载之前
    beforeMount() {
    },
    // 生命周期 - 挂载完成（可以访问 DOM 元素）
    mounted() {
    },
    // 生命周期 - 更新之前
    beforeUpdate() {
    },
    // 生命周期 - 更新之后
    updated() {
    },
    // 生命周期 - 销毁之前
    beforeDestroy() {
    },
    // 生命周期 - 销毁完成
    destroyed() {
    },
    // 如果页面有 keep-alive 缓存功能,这个函数会触发
    //进入的时候触发
    activated() {
    },
    //离开的时候触发
    deactivated() {
    },
}
</script>

<style scoped lang="scss">
.productTypeDialog /deep/ .el-dialog {
    margin-left: 50px !important;
    width: 800px !important;
}
#left {
    width: 500px;
    /deep/ #middle {
        width: 500px;
        height: 300px;
    }
}
#right {
    margin-left: 30px;
    margin-top: 30px;
    >p {
        margin-top: 6px;
    }
}
</style>